import type { ComponentProps } from 'react';
import { TeamFlag } from './TeamFlag';

type Size = NonNullable<ComponentProps<typeof TeamFlag>['size']>;

// Crown width per flag size — sits centered above the tile, slightly
// overlapping its top edge.
const CROWN_WIDTH: Record<Size, number> = {
  xs: 15,
  sm: 19,
  md: 30,
  lg: 38,
};

/**
 * Renders a {@link TeamFlag}, with a gold crown perched on top when
 * `crowned` is set — used to mark the #1 user in the standings.
 */
export function CrownedFlag({
  crowned = false,
  ...props
}: ComponentProps<typeof TeamFlag> & { crowned?: boolean }) {
  if (!crowned) return <TeamFlag {...props} />;

  const w = CROWN_WIDTH[props.size ?? 'sm'];
  return (
    <span style={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
      <TeamFlag {...props} />
      <svg
        viewBox="0 0 24 16"
        width={w}
        height={(w * 16) / 24}
        aria-hidden
        style={{
          position: 'absolute',
          left: '50%',
          top: 0,
          transform: 'translate(-50%, -68%)',
          color: 'var(--sun)',
          filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, 0.45))',
          pointerEvents: 'none',
        }}
      >
        <path
          d="M3 14 L3 4 L8 9 L12 2 L16 9 L21 4 L21 14 Z"
          fill="currentColor"
          stroke="rgba(0, 0, 0, 0.35)"
          strokeWidth="0.75"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
